import defaultConfig from './default.json';
import demoConfig from './demo.json';
import groceryConfig from './grocery.json';
import fishConfig from './fish.json';
import meatConfig from './meat.json';
import restaurantConfig from './restaurant.json';
import publicationConfig from './publication.json';
import petConfig from './pet.json';
import coffeeConfig from './coffee.json';

export const industryConfigs = {
  default: defaultConfig,
  demo: demoConfig,
  grocery: groceryConfig,
  fish: fishConfig,
  meat: meatConfig,
  restaurant: restaurantConfig,
  publication: publicationConfig,
  pet: petConfig,
  coffee: coffeeConfig,
};
